import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';


export class gameOpinionDisplay extends cDisplay {

  private ccList: number[]
  private curSlide: any;
  private slideIndex: number = 0;
  private qData: any;
  private cc: number = 0
  private score: number = 0

  init(){
    super.init();

    (this.scene as cScene).ev.addListener('action',(command,options)=>{
      switch (options.command ){
        case 'next_opinion':
          console.log('action ','next_option')
          this.nextOpinion();
          break;
        case 'next_slide':
          this.nextSlide();
          break;
        case 'eval':
          var answer = (this.scene as cScene).getState('answer');
          var isCorrect = (Number(answer) == this.curSlide.answer);
          this.score += isCorrect ? 1 : 0;
          (this.scene as cScene).triggerSceneEvent('answer',{
            'info': isCorrect ? this.curSlide.correct : this.curSlide.false,
            'correct': isCorrect ? 1 : 0
          });
          break;
      }
    })
  }

  buildScene(){
    super.buildScene();
    var d:cSprite = this.getByName('DATA')
    if (d){
      this.qData = d.modules.data._extraData
      this.ccList = [...this.qData].sort( ()=>0.5-Math.random())      
    }
  }

  nextOpinion(){
    if (this.ccList.length === 0){
      (this.scene as cScene).triggerSceneEvent('completed',{
        score: ['opinion',this.score,this.qData.length].join(':'),
      })
    }else{
      this.curSlide = this.ccList.pop();
      this.slideIndex = 1;
      this.cc ++;
      (this.scene as cScene).triggerSceneEvent('quiz',{
        'title': this.curSlide.title,
        'img'  : this.curSlide.prefix + this.slideIndex + '.jpg'
      })  
    }
  }

  nextSlide(){
    this.slideIndex++
    console.log(this.slideIndex, this.curSlide.count)
    if (this.slideIndex > this.curSlide.count){
      (this.scene as cScene).triggerSceneEvent('input',{
        textleft: this.curSlide.textleft,
        textright: this.curSlide.textright,
        index: this.curSlide.index
      });
    }else{
      (this.scene as cScene).triggerSceneEvent('slide',{
        'img'  : this.curSlide.prefix + this.slideIndex + '.jpg'
      });
    }
  }

  mounted(){
    this.nextOpinion();
  }




}
